import { useEffect, useRef, useState } from "react";

export default function AnimatedCounter({ value, className = "", testId }) {
  const ref = useRef(null);
  const [display, setDisplay] = useState(value);

  useEffect(() => {
    // Parse leading number if present, keep suffix/prefix
    const match = String(value).match(/^([^\d]*)([\d,]+)(.*)$/);
    if (!match) {
      setDisplay(value);
      return;
    }
    const prefix = match[1];
    const target = parseInt(match[2].replace(/,/g, ""), 10);
    const suffix = match[3];
    let started = false;
    const el = ref.current;
    const run = () => {
      if (started) return;
      started = true;
      const dur = 1600;
      const t0 = performance.now();
      const step = (t) => {
        const p = Math.min(1, (t - t0) / dur);
        const eased = 1 - Math.pow(1 - p, 3);
        const cur = Math.floor(eased * target);
        setDisplay(prefix + cur.toLocaleString() + suffix);
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && run()),
      { threshold: 0.4 }
    );
    if (el) obs.observe(el);
    return () => obs.disconnect();
  }, [value]);

  return (
    <span ref={ref} className={className} data-testid={testId}>
      {display}
    </span>
  );
}
